// Drag an email row (or the whole selection) from the PandaAI Email list onto a label in the sidebar
// to apply that label. The drag carries the email ids as a JSON array under this type, so the label
// rows (and the collapsed sidebar rail) react to email drags only — never to files or text.
export const EMAIL_DRAG_TYPE = 'application/x-pandaai-email';

export const isEmailDrag = (e: { dataTransfer: DataTransfer }) => Array.from(e.dataTransfer.types || []).includes(EMAIL_DRAG_TYPE);
